'use strict';

var React = require('react');
var GenericIconWeb = require('@swiggy-private/dls-web-icons/dist/GenericIconWeb');
var chevronRight = require('@swiggy-private/dls-web-icons/dist/web/generic/chevronRight');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Icon = ({ name, attrs, style }) => {
    const icon = React.useMemo(() => {
        switch (name) {
            case "ChevronRight":
                return chevronRight.Svg16;
            default:
                return null;
        }
    }, [name]);
    if (!icon) {
        return null;
    }
    return React__default['default'].createElement(GenericIconWeb.GenericIcon, Object.assign({}, attrs, { style: style, Icon: icon, "data-testid": "text-btn-right-icon" }));
};
var Icon$1 = React__default['default'].memo(Icon);

exports.Icon = Icon$1;
//# sourceMappingURL=Icon-a078562e.js.map
